import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
`

export const styles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: 'white'
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 12
  },
  userButton: {
    marginLeft: 12,
    marginRight: -12
  },
  card: {
    marginTop: 30,
    maxWidth: 600,
    paddingBottom: 15
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  avatarWrapper: {
    display: 'flex',
    margin: '1em',
    justifyContent: 'center'
  },
  avatar: {
    width: '6em',
    height: '6em'
  },
  input: {
    display: 'none'
  }
}



// WEBPACK FOOTER //
// ./src/components/LocationSignUp/LocationListSignUp/styles.js